'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var TextInput = require('@narvar/nth-block-text-input');
var Button = require('@narvar/nth-block-button');
var nthHookTheme = require('@narvar/nth-hook-theme');
var index = require('../../components/Language/index.js');
require('../../components/Spinner/Spinner.module.css.js');
require('@babel/runtime/helpers/extends');
require('../../components/LocationCard/LocationCard.js');
require('../../components/PudoCard/PudoCard.js');
require('../../components/ItemCard/ItemCard.js');
require('../../components/SelectItem/SelectItem.js');
require('../../components/SelectList/SelectList.js');
require('../../components/ErrorBanner/ErrorBanner.js');
require('../../components/Footer/Footer.js');
require('../../components/StickyFooter/StickyFooter.js');
require('../../components/SwatchesList/SwatchesList.js');
require('@narvar/nth-bit-text-link');
require('../../components/Backdrop/Backdrop.module.css.js');
require('../../components/LineItemsGroup/index.js');
require('../../components/Skeleton/Skeleton.module.css.js');
var useLanguage = require('../../hooks/language/useLanguage.js');
var OrderLookup_module = require('./OrderLookup.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const FormFieldsC = _ref => {
  let {
    giftReturn,
    fields,
    values,
    onSubmit,
    onChange
  } = _ref;
  const [elId] = React.useState(`order-lookup-form-${Math.random()}`);
  const [formStatus, setFormStatus] = React.useState(values ?? fields.map(_ref2 => {
    let {
      type
    } = _ref2;
    return {
      value: '',
      type
    };
  }));
  const showingFields = field => giftReturn || field.type !== 'GIFT_CODE';
  const {
    bodytextDefaultNone,
    captiontextDefaultNone,
    captiontextErrorNone
  } = nthHookTheme.useTheme();
  const {
    returnsOrderLoginFormSubmit,
    returnsOrderLoginFormLabelEmail,
    returnsOrderLoginFormLabelOrder
  } = nthHookTranslations.useTranslations();
  const labels = {
    returnsOrderLoginFormLabelEmail,
    returnsOrderLoginFormLabelOrder,
    returnsOrderLoginFormLabelGiftCode: useLanguage["default"]({
      langKey: 'returnsOrderLoginFormLabelGiftCode'
    }).value
  };
  const captions = {
    returnsOrderLoginFormCaptionEmail: useLanguage["default"]({
      langKey: 'returnsOrderLoginFormCaptionEmail'
    }).value,
    returnsOrderLoginFormCaptionOrder: useLanguage["default"]({
      langKey: 'returnsOrderLoginFormCaptionOrder'
    }).value,
    returnsOrderLoginFormCaptionGiftCode: useLanguage["default"]({
      langKey: 'returnsOrderLoginFormCaptionGiftCode'
    }).value
  };
  const submitHandler = e => {
    e.preventDefault();
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
      value: formStatus.filter(showingFields),
      event: 'submit',
      area: 'orderLogin'
    });
  };

  // For controlled, stateless, pure component, refresh the locate state base on the props
  React.useEffect(() => values && setFormStatus(values), [values]);
  const handleChange = (e, i) => {
    const updatedForm = [...formStatus];
    updatedForm[i] = {
      ...updatedForm[i],
      value: e
    };
    setFormStatus(updatedForm);
    onChange === null || onChange === void 0 ? void 0 : onChange({
      value: updatedForm.filter(showingFields),
      event: 'change',
      area: 'orderLogin'
    });
  };
  return /*#__PURE__*/React__default["default"].createElement("form", {
    className: OrderLookup_module["default"].formFieldsWrapper,
    onSubmit: submitHandler
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsOrderLoginFieldsAbove"
  }), fields.filter(showingFields).map((_ref3, i) => {
    var _formStatus$filter$i;
    let {
      type,
      label,
      caption,
      error,
      errorMsg
    } = _ref3;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, {
      key: i
    }, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(TextInput__default["default"], {
      id: `${elId}-${type}`,
      value: (_formStatus$filter$i = formStatus.filter(showingFields)[i]) === null || _formStatus$filter$i === void 0 ? void 0 : _formStatus$filter$i.value,
      onChange: e => handleChange(e.target.value, i),
      animateLabel: true,
      error: error,
      containerOverridesStyle: {
        ...(error ? {
          borderColor: (captiontextErrorNone === null || captiontextErrorNone === void 0 ? void 0 : captiontextErrorNone.color) || '#E02020'
        } : undefined),
        fontSize: '16px'
      },
      type: type === 'EMAIL' ? {
        EMAIL: TextInput.SupportedInputType.email
      }[type] : TextInput.SupportedInputType.text,
      label: labels[label] ?? undefined
    }), giftReturn && captions[caption] && /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        ...bodytextDefaultNone,
        ...captiontextDefaultNone
      }
    }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: caption
    }))), error && errorMsg && /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        ...bodytextDefaultNone,
        ...captiontextErrorNone
      }
    }, errorMsg));
  }), /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsOrderLoginSubmitAbove"
  }), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    type: Button.ButtonType.submit,
    onClick: submitHandler,
    disabled: formStatus.some(field => field.value === '' && showingFields(field))
  }, returnsOrderLoginFormSubmit), /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsOrderLoginSubmitBelow"
  }));
};
const FormFields = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(FormFieldsC, {
  themeTokens: ['bodytextDefaultNone', 'captiontextDefaultNone', 'captiontextErrorNone']
}), {
  translationKeys: ['returnsOrderLoginFormSubmit', 'returnsOrderLoginFormLabelEmail', 'returnsOrderLoginFormLabelOrder']
});

exports.FormFields = FormFields;
